import styled from "styled-components";
import Background from "../../assets/images/thetower.png";

export const Container = styled.main`
  height: 100vh;
  width: 100vw;
  background-image: url(${Background});
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .a-droga-da-div-pai {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90%;
  }

  .leaderboard {
    position: absolute;
    left: 100px;
    top: 150px;
    width: 350px;

    h3 {
      font-size: 19px;
    }
  }

  .chars-leaderboard {
    max-height: 520px;
    overflow-y: auto;
  }

  .char-leaderboard {
    position: initial;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    h1 {
      text-align: left;
      width: 100%;
      font-size: 15px;
      margin: 5px;
      padding: 0;
    }

    p {
      margin: 5px;
    }
  }

  .back-dash {
    position: absolute;
    left: 80px;
    top: 80px;
    width: 390px;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;

    p {
      display: flex;
      align-items: center;
    }

    svg {
      font-size: 30px;
      color: #834c33;
      margin-left: 5px;
    }
  }

  .levels {
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-around;
    width: 600px;

    button {
      width: 250px;
    }

    .par {
      margin-left: 400px;
    }

    .impar {
      margin-right: 400px;
    }
  }
`;
